query VideoFile($id: ID!) {
  videoFile(id: $id) {
    id
    status
    fileName
    size
    duration
    width
    height
    playlistUrl
    posterUrl
    error
    createdAt
  }
}
